import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { from, switchMap } from 'rxjs';
import { AccessService } from '@shared-lib/foundry-shared/access.service';

export const authHeadersInterceptor: HttpInterceptorFn = (req, next) => {
  const access = inject(AccessService);
  const requestPath = (() => {
    try {
      return new URL(req.url, window.location.origin).pathname;
    } catch {
      return req.url.split(/[?#]/, 1)[0];
    }
  })();

  if (/^\/assets(?:\/|$)/i.test(requestPath) || req.headers.has('Authorization')) {
    return next(req);
  }

  return from(access.getValidToken()).pipe(
    switchMap((token) => next(token
      ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
      : req)),
  );
};
